const Label = (props) => {
    const style = {
      ...props.style,
      margin: '0 0 8px 8px',
      display: 'inline-block'
    };
  
    return <label {...props} style={style}>{props.children} {props.require ? <span className="asterisk">*</span> : null}</label>
};
  
export default Label;